<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Vue from "vue";
import { Icons } from "vue-ydui/dist/lib.rem/icons";
Vue.component(Icons.name, Icons);
export default {
  name: "App",
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    if (sessionStorage.getItem("isLogin")) {
      this.$store.dispatch("getInfo");
    } else {
      this.$store.dispatch("loginInfo");
    }
  },
  mounted() {
    //阻止到首页后继续后退
    //history.pushState(null, null, document.URL);
    window.addEventListener("popstate", e => {
      if (e.target.location.hash == "#/App/Home") {
        history.pushState(null, null, e.target.location.href);
      }
      //history.pushState(null, null, document.URL);
    });
  },
  data() {
    return {
      routeNme: ""
    };
  },
  //监听路由变化修改当前高亮active
  watch: {
    $route: function(route) {
      // console.log(route.name, '路由名称');
      this.routeNme = route.name;
    }
  },
  methods: {
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}

html,
body,
#app {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  overflow-y: scroll;
  background-color: #f5f5f5;
}
</style>



// WEBPACK FOOTER //
// src/App.vue